package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.physical.PhysicalNetwork
import org.molap.datetime.DateTimeTz
import kotlin.reflect.KClass

class SubstationNetworkBuilder(val time: DateTimeTz, val physicalNetwork: PhysicalNetwork) {
    private val capabilities = mutableMapOf<KClass<out NetworkCapability>, NetworkCapability>()

    fun <T : NetworkCapability> add(capability: T) {
        capabilities[capability::class] = capability
    }

    fun build(): SubstationNetwork = SubstationNetwork(time, physicalNetwork, capabilities)
}